(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ap-whatsapp"] && !Shopify.designMode) return;
  try {
     
  class KsWhatsAppChat extends HTMLElement {
    constructor () {
      super ()

      this.chatButton = this.querySelector('#ks-whatsapp-chat-btn')
      this.dialog = this.querySelector('#ks-whatsapp-chat-dialog')
      this.userForm = this.querySelector('#ks-whatsapp-chat-dialog-user-form')
      this.userInput = this.querySelector('#ks-whatsapp-chat-dialog-user-input')
      this.whatsappNumber = this.dataset.whatsappNumber.split('-').join('')
      
      this.handleChatButtonClick()
      this.handelCloseDialogButtonClick()
      this.handleKeyboardIssueMobile()
      this.handleFormSubmit()
    }

    handleChatButtonClick () {
      this.chatButton.addEventListener('click', () => {
        if (this.dataset.hasDialog === 'true') {
          this.openDialog()
        } else {
          this.chatButton.classList.add('loading')
          setTimeout(() => {
            window.open(`https://wa.me/${this.whatsappNumber}`, '_blank')
            this.chatButton.classList.remove('loading')
          }, 1000)
        }
      })
    }

    openDialog () {
      if (this.dialog.hasAttribute('open')) {
        this.closeDialog()
        return
      }

      this.dialog.setAttribute('open', '')
      this.setAttribute('data-dialog-open', 'true')

      setTimeout(() => {
        this.querySelector('#ks-whatsapp-chat-dialog-user-input').focus()
      }, 3000)
    
      setTimeout(() => {
        this.querySelector('#ks-whatsapp-chat-dialog-msg-typing').style.display = 'none'
        this.querySelector('#ks-whatsapp-chat-dialog-msg-text').style.display = 'block'
      }, 2000)

      this.trapFocus()
    }

    closeDialog () {
      this.dialog.removeAttribute('open')
      this.setAttribute('data-dialog-open', 'false')
      this.chatButton.focus()
    }
    
    handelCloseDialogButtonClick () {
      this.querySelector('#ks-whatsapp-chat-dialog-close').addEventListener('click', () => {
        this.closeDialog()
      })
    }

    handleKeyboardIssueMobile () {
      this.userInput.addEventListener('focus', () => {
        this.dialog.setAttribute('data-keyboard-open', '')
      })
      this.userInput.addEventListener('blur', () => {
        this.dialog.removeAttribute('data-keyboard-open')
      })
    }

    trapFocus() {
      const focusableElements = this.dialog.querySelectorAll(
        'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
      )
      const firstElement = focusableElements[0]
      const lastElement = focusableElements[focusableElements.length - 1]

      function handleTab(event) {
        if (event.key === 'Tab') {
          if (event.shiftKey && document.activeElement === firstElement) {
            event.preventDefault()
            lastElement.focus()
          } else if (!event.shiftKey && document.activeElement === lastElement) {
            event.preventDefault()
            firstElement.focus()
          }
        }
      }

      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.closeDialog())

      this.dialog.addEventListener('keydown', handleTab)

      return () => {
        this.dialog.removeEventListener('keydown', handleTab)
      }
    }

    handleFormSubmit () {
      this.userForm.addEventListener('submit', (event) => {
        event.preventDefault()
         this.querySelector('#ks-whatsapp-chat-dialog-btn').classList.add('loading')

         setTimeout(() => {
          if (this.userInput.value) {
              const text = encodeURIComponent(this.userInput.value)
              window.open(`https://wa.me/${this.whatsappNumber}?text=${text}`, '_blank')
          } else {
            window.open(`https://wa.me/${this.whatsappNumber}`, '_blank')
          }

          this.querySelector('#ks-whatsapp-chat-dialog-btn').classList.remove('loading')
        }, 1000)
      })
    }
  }
  customElements.define('ks-whatsapp-chat', KsWhatsAppChat)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["infinite-marquee"] && !Shopify.designMode) return;
  try {
    
  class KsMarquee extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
      this.handleResize = this.debounce(() => this.reInit(), 200);
      this.handleSectionLoad = this.handleSectionLoad.bind(this);
    }

    connectedCallback() {
      this.init();
      window.addEventListener('resize', this.handleResize);
      document.addEventListener('shopify:section:load', this.handleSectionLoad);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      document.removeEventListener('shopify:section:load', this.handleSectionLoad);
    }

    handleSectionLoad(event) {
      if (event.target && event.target.contains(this)) {
        this.reInit();
      }
    }

    debounce(fn, delay) {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), delay);
      };
    }

    reInit() {
      const inner = this.querySelector('.ks-marquee-inner');
      if (!inner) return;

      inner.querySelectorAll('.is-clone').forEach((el) => el.remove());

      const existingStyle = document.getElementById('ks-marquee-style-' + this.dataset.sectionId);
      if (existingStyle) existingStyle.remove();

      this.initialized = false;
      this.init();
    }

    init() {
      if (this.initialized) return;

      const inner = this.querySelector('.ks-marquee-inner');
      const track = this.querySelector('.ks-marquee-track');
      if (!inner || !track) return;

      const clone = track.cloneNode(true);
      clone.classList.add('is-clone');
      clone.setAttribute('aria-hidden', 'true');

      clone.querySelectorAll('a, button, input, select, textarea').forEach((el) => {
        el.setAttribute('tabindex', '-1');
      });

      clone.querySelectorAll('[id]').forEach((el) => {
        el.removeAttribute('id');
      });

      inner.appendChild(clone);

      const trackWidth = track.scrollWidth;
      const duration = parseFloat(this.dataset.animationDuration) || 30;
      const direction = this.dataset.marqueeDirection || 'left';
      const animationName = 'ks-marquee-animation-' + this.dataset.sectionId;
      const styleId = 'ks-marquee-style-' + this.dataset.sectionId;

      const style = document.createElement('style');
      style.id = styleId;

      if (direction === 'right') {
        style.textContent = `
          #ks-marquee-${this.dataset.sectionId} .ks-marquee-inner {
            animation: ${animationName} ${duration}s linear infinite;
          }

          @keyframes ${animationName} {
            from { transform: translateX(-${trackWidth}px); }
            to { transform: translateX(0); }
          }
        `;
      } else {
        style.textContent = `
          #ks-marquee-${this.dataset.sectionId} .ks-marquee-inner {
            animation: ${animationName} ${duration}s linear infinite;
          }

          @keyframes ${animationName} {
            from { transform: translateX(0); }
            to { transform: translateX(-${trackWidth}px); }
          }
        `;
      }

      document.head.appendChild(style);
      this.initialized = true;
    }
  }

  if (!customElements.get('ks-marquee')) {
    customElements.define('ks-marquee', KsMarquee);
  }

  } catch(e) { console.error(e); }
})();
})();
